import Header from './components/header';
import './App.css';
import About from './components/about';
import Service from './components/service';
import Products from './components/products';
import Contact from './components/contact';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/home';
import ArktemisPage from './components/arktemispage';
import PostList from './components/PostList';
import PostDetail from './components/PostDetail';
import NotFound from './components/NotFound';
import FloatingIcons from './components/FloatingIcons';
import { useEffect } from 'react'; // Import useEffect
import AOS from 'aos'; // Import AOS
import 'aos/dist/aos.css'; // Import AOS CSS

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // values from 0 to 3000, with step 50ms
      once: true,     // whether animation should happen only once - while scrolling down
    });
  }, []); // Empty dependency array means this runs once on mount

  return (
    <BrowserRouter>
      <div className="App">
        <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/service" element={<Service />} />
          <Route path="/products" element={<Products />} />
          <Route path="/posts" element={<PostList />} />
          <Route path="/posts/:slug" element={<PostDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/arktemispage" element={<ArktemisPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <FloatingIcons />
      </div>
    </BrowserRouter>
  );
}

export default App;
